






























import { Component, Vue, Watch } from 'vue-property-decorator'
import PuzzleCover from '@/components/PuzzleCover.vue'
import PuzzleItem from '@/components/PuzzleItem.vue'

import { PuzzleData } from './siteFuture'

@Component({
  components: {
    PuzzleCover,
    PuzzleItem
  }
})
export default class App extends Vue {

  private width: number = 0

  get puzzle(): PuzzleData[] {
    return this.$store.state.puzzle;
  }

  /** 遊戲完成狀態 */
  get complete(): boolean {
    return this.$store.state.complete;
  }
  set complete(val: boolean) {
    const { commit } = this.$store;
    commit('SET_COMPLETE', val);
  }

  /** 遊戲進行中flag */
  get play(): boolean {
    return this.$store.state.play;
  }
  set play(type: boolean) {
    const { commit } = this.$store;
    commit('SET_PLAY_TYPE', type);
  }

  /** 計步器 */
  get moves(): number {
    return this.$store.state.moves;
  }
  set moves(num: number) {
    this.$store.commit('RESET_MOVE', 0)
  }

  get itemWidth(): number {
    const { width } = this
    return width > 667? 120 : 77
  }

  mounted() {
    this.getWindowWidth()
    window.addEventListener('resize', this.getWindowWidth)
  }

  beforeDestory() {
    window.removeEventListener('resize', this.getWindowWidth)
  }

  private getWindowWidth(): void {
    this.width = window.innerWidth
  }

  /**
   * 開始新局
   * 如果是完成的狀態按下 play 就歸零計步器
   * 完成狀態改成：未完成
   * */
  private initePuzzleData(): void {
    this.$store.dispatch('INIT_PUZZLE');
    this.moves = 0
    this.complete = false
  }

  /** 遊戲開始結束 */
  private playToggle(): void {
    this.initePuzzleData()
    this.play = !this.play;
  }

  /** 重置 */
  private handleRest(): void {
    this.initePuzzleData()
  }

  /** 每移動一次就做一次檢查 */
  @Watch('puzzle', { deep: true })
  puzzleDataChange(val: PuzzleData[]): void {
    /** 這裡很麻煩不能直接拿兩個陣列相比，要比每一個值 */
    const complete = val.every(
      (item: PuzzleData) => item.value.join('') === item.position.join(''));
    if( complete ) {
      this.complete = true
      /** 等動畫做完 */
      setTimeout(() => { this.play = false }, 1000)
    }
  }
}
